import React from 'react';

const TableScroll = ({ children, minWidth = 720, style = {} }) => (
  <div
    className="table-scroll-container"
    style={{
      width: '100%',
      overflowX: 'auto',
      overflowY: 'visible',
      WebkitOverflowScrolling: 'touch',
      ...style,
    }}
  >
    {children}
  </div>
);

export const tableBaseStyle = {
  width: '100%',
  borderCollapse: 'collapse',
};

export default TableScroll;
